export default {
  // 'WHATSAPP.TEMPLATE.LIST.TITLE': 'WhatsApp 模板',
  'WHATSAPP.TEMPLATE.LIST.MARKET': '营销',
  'WHATSAPP.TEMPLATE.LIST.UTILITY': '实用',
  'WHATSAPP.TEMPLATE.LIST.ADD.TEMPLATE': '创建WhatsApp模板',
  'WHATSAPP.TEMPLATE.LIST.STATUS.ALL': '所有状态',
  'WHATSAPP.TEMPLATE.LIST.STATUS.DRAFT': '草稿',
  'WHATSAPP.TEMPLATE.LIST.STATUS.APPROVED': '已批准',
  'WHATSAPP.TEMPLATE.LIST.STATUS.REJECTED': '已拒绝',
  'WHATSAPP.TEMPLATE.LIST.STATUS.PENDING': '待审核',
  'WHATSAPP.TEMPLATE.LIST.STATUS.PAUSED': '已暂停',
  'WHATSAPP.TEMPLATE.LIST.STATUS.DISABLED': '已禁用',

  'WHATSAPP.TEMPLATE.MANAGE.NAME': '模板名称',
  'WHATSAPP.TEMPLATE.MANAGE.LANGUAGE': '语言',
  'WHATSAPP.TEMPLATE.MANAGE.QUALITY': '质量',
  'WHATSAPP.TEMPLATE.MANAGE.CONTENT': '内容',
  'WHATSAPP.TEMPLATE.MANAGE.STATUS': '状态',
  'WHATSAPP.TEMPLATE.MANAGE.ACTION': '操作',

  'WHATSAPP.TEMPLATE.LIST.QUALITY.GREEN': '高',
  'WHATSAPP.TEMPLATE.LIST.QUALITY.YELLOW': '中',
  'WHATSAPP.TEMPLATE.LIST.QUALITY.RED': '低',
  'WHATSAPP.TEMPLATE.LIST.QUALITY.UNKNOWN': '质量待定',

  'WHATSAPP.TEMPLATE.MANAGE.STATUS.PLACEHOLDER': '模板状态',

  'WHATSAPP.TEMPLATE.LIST.DELETE.DIALOG.HEADER': '确定删除WhatsApp模板?',
  'WHATSAPP.TEMPLATE.LIST.DELETE.DIALOG.BODY':
    "删除<b class='color-333'><span>{name}</span></b>后，模板信息不可恢复",

  'WHATSAPP.TEMPLATE.LIST.PREVIEW.TITLE': '预览',

  'WHATSAPP.TEMPLATE.LIST.CREATE.TITLE.MARKETING': '创建WhatsApp营销模板',
  'WHATSAPP.TEMPLATE.LIST.CREATE.TITLE.UTILITY': '创建实用模板',

  'WHATSAPP.TEMPLATE.MANAGE.CREATE.LANGUAGE': '模板语言',
  'WHATSAPP.TEMPLATE.MANAGE.CREATE.LANGUAGE.PLACEHOLDER': '选择模板语言',
  'WHATSAPP.TEMPLATE.MANAGE.CREATE.SENDER.NUMBER': '关联账号',
  'WHATSAPP.TEMPLATE.MANAGE.CREATE.SENDER.SELECT.PLACEHOLDER': '请选择关联账号',
  'WHATSAPP.TEMPLATE.LIST.CREATE.NAME.UNABLE.EMPTY': '请输入名称',
  'WHATSAPP.TEMPLATE.LIST.CREATE.NAME.UNABLE.CHARACTER':
    '仅允许输入小写字母，数字，下划线',
  'WHATSAPP.TEMPLATE.LIST.CREATE.NAME.UNABLE.REPEAT': '名称不可重复',

  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.SUBMIT.APPROVAL': '提交审核',
  'WHATSAPP.TEMPLATE.CREATE.ADD.BUTTONS': '添加按钮',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.TEXT': '请输入按钮文本',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.URL': '请输入链接',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.TEXT.REPEAT': '您无法为多个按钮输入相同文本',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.URL.UNABLE.EMPTY':
    '需输入有效 URL，请检查拼写并确保URL以http://, https://或 whatsapp-smb://开头',

  'WHATSAPP.TEMPLATE.CREATE.HEADER.TEXT.SPECIAL.ERROR':
    '标题不能包含任何换行符、格式设置字符、表情符号或星号',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.TEXT.SPECIAL.ERROR':
    '按钮文本不能包含任何换行符、格式设置字符或表情符号',

  'WHATSAPP.TEMPLATE.CREATE.FOOTER.TEXT.SPECIAL.ERROR':
    '模板脚部不能包含任何换行符、格式设置字符、表情符号或星号',

  'WHATSAPP.TEMPLATE.CREATE.FOOTER.TEXT.UNABLE.EMPTY': '不能为空',

  'WHATSAPP.TEMPLATE.CREATE.HEADER.TEXT.INPUT': '请输入模板头部文本',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT.INPUT': '请输入模板主体文本',
  'WHATSAPP.TEMPLATE.CREATE.FOOTER.TEXT.INPUT': '请输入模板脚部文本',

  'WHATSAPP.TEMPLATE.CREATE.HEADER.MEDIA.UPLOAD': '上传图片',

  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.SUBMIT.APPROVAL.ERROR':
    '获取模板数据失败模板内容',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.SUBMIT.APPROVAL.SUCCESS': '已提交审批',

  'WHATSAPP.TEMPLATE.LIST.CREATE.SELECT.SENDER.NUMBER.TIPS.SUCCESS':
    '请选择将用于关联并提交审批的发件账号',
  'WHATSAPP.TEMPLATE.LIST.CREATE.TITLE.TIPS': '配置 WhatsApp 模板',
  'WHATSAPP.TEMPLATE.LIST.CREATE.HEADER': '模板头部',
  'WHATSAPP.TEMPLATE.LIST.CREATE.HEADER.TEXT': '文本',
  'WHATSAPP.TEMPLATE.LIST.CREATE.HEADER.MEDIA': '富媒体',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BODY': '模板主体',
  'WHATSAPP.TEMPLATE.LIST.CREATE.FOOTER': '模板脚部',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON': '模板按钮',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.ADD.TIPS':
    '添加按钮以允许收件人快速执行操作（如访问网站），最多支持添加两个。',

  'WHATSAPP.TEMPLATE.MANAGE.ADD.TEMPLATE.TITLE': '创建第一个WhatsApp模板',
  'WHATSAPP.TEMPLATE.MANAGE.ADD.TEMPLATE.DES': '创建模板后，可以在活动中使用',
  'WHATSAPP.TEMPLATE.MANAGE.ADD.TEMPLATE': ' 创建WhatsApp模板',

  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.TEXT': '按钮文本',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.URL': '链接地址',

  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.TEXT.UNABLE.EMPTY': '按钮文本不能为空',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.TEXT.INPUT': '请输入按钮文本',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.URL.UNABLE.EMPTY': '链接地址不能为空',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.URL.INPUT': '请输入链接地址',

  'WHATSAPP.TEMPLATE.CREATE.SAVE.DRAFT.TITLE': '确定是否保存修改内容?',
  'WHATSAPP.TEMPLATE.CREATE.SAVE.DRAFT.DESC':
    '选择不保存，您修改的内容将被删除且不可恢复。选择保存，可保存新修改内容',

  'WHATSAPP.TEMPLATE.EDITING.TIPS': '*不允许多人同时编辑',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT.CONTACT.ERROR':
    '联系人字段不允许出现在开头和结尾',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT.VAR.ERROR':
    '正文词汇总数需控制在联系人字段总数的 3 倍以上。',

  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.APPROVAL':
    '确认提交审核？',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.SAVE': '确认保存？',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.DESC.TIPS1': '检测到模板内存在',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.DESC.TIPS2':
    '如需插入联系人字段，<b>请选择系统内已存在</b>联系人字段插入。',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.LABEL.DES.WHATSAPP':
    '消息发送后，会使用系统内联系人信息替换',
  'WHATSAPP.TEMPLATE.CREATE.TEXT.TIP.LIMIT': '已超过最大字数限制',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.SAVE.ERROR': '保存失败',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.APPROVAL.ERROR':
    '提交失败',
};
